import { createFileRoute } from '@tanstack/react-router';
import { DevicesPage } from '@/features/attendance/devices-page';
import { guardRoute } from '@/lib/route-guards';

/** `/hr/attendance/devices` (FR-ATT-5/6, attendance.manage): biometric devices and unmapped punches. */
export const Route = createFileRoute('/_app/hr/attendance_/devices')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/hr/attendance/devices');
  },
  component: DevicesPage,
});
